import ReactDOM from "react-dom";
import "./sass/index.css";
import Root from "./root/Root";
import App from "./App";

ReactDOM.render(
  <Root>
    <App />
  </Root>,
  document.getElementById("root")
);
